import React from 'react';
import createReactClass from 'create-react-class';
import EasyPieChart from '../common/Diagrams/EasyPieChart';

var StorageLocation = createReactClass({
  getDefaultProps(){
    return {
      color: '#CCCCCC',
      totalStockValue: 0,
      storageLocation: {
        totalStockValue: 0,
        entries: []
      },
    };
  },

  render() {
    const { totalStockValue, storageLocation, color } = this.props;

    let percent = 0;
    if(totalStockValue > 0) {
      percent = Math.round((storageLocation.totalStockValue / totalStockValue) * 100);
    }

    let isIncreasing = false;

    if(storageLocation.entries.length > 0) {
      isIncreasing = storageLocation.entries[0].value <= storageLocation.entries[storageLocation.entries.length-1].value;
    }

    const indicatorClassName = isIncreasing ?
      'fa fa-caret-up icon-color-bad' :
      'fa fa-caret-down icon-color-good';

    let sparklineChart = (<span style={{width: 100}}>Neuer Lagerort</span>);
    if(storageLocation.entries.length > 1) {
      sparklineChart = (
        <div className="sparkline txt-color-greenLight hidden-sm hidden-md" data-sparkline-type="line" data-sparkline-height="33px" data-sparkline-width="100px" data-fill-color="transparent" data-sparkline-tooltipformat="€{{value}}">
            {storageLocation.entries.map(x => Math.round(x.value * 100) / 100).join()}
        </div>
      );
    }

    return (
      <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center'}}>
            <EasyPieChart percent={percent} isIncreasing={isIncreasing} color={color} />

            <h5 className="hidden-sm" style={{color, marginLeft: 10, marginRight: 10, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center'}}>
              <span>{storageLocation.name} €{storageLocation.totalStockValue.toFixed(2)}</span>
            </h5>

            <i className={indicatorClassName}></i>
          </div>

          {sparklineChart}
        </div>
      </div>
    );
  }
});

export default StorageLocation;



// WEBPACK FOOTER //
// ./src/components/dashboard/StorageLocation.js